import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import BoxBuilder from "@/components/BoxBuilder/BoxBuilder";
import "@/styles.css";

const MOUNT_ID = "biab-root";

function mount(el: HTMLElement) {
  // Every usage of the widget is scoped so our Tailwind utilities don't leak
  // to the rest of the WP page, and the host theme doesn't leak into us.
  if (!el.classList.contains("biab-scope")) {
    el.classList.add("biab-scope");
  }
  createRoot(el).render(
    <StrictMode>
      <BoxBuilder />
    </StrictMode>,
  );
}

function bootstrap() {
  // Support multiple mounts on the same page (future-proofing).
  const nodes = document.querySelectorAll<HTMLElement>(`[id^="${MOUNT_ID}"]`);
  let found = 0;
  nodes.forEach((el) => {
    if (el.dataset.biabMounted === "1") return;
    el.dataset.biabMounted = "1";
    mount(el);
    found += 1;
  });
  if (found === 0 && document.getElementById(MOUNT_ID)) {
    const el = document.getElementById(MOUNT_ID);
    if (el && el.dataset.biabMounted !== "1") {
      el.dataset.biabMounted = "1";
      mount(el);
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrap);
} else {
  bootstrap();
}
